/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AcceptInviteResponse,
  CancelInvitation200Response,
  Company,
  CompanyDetailed,
  CreateCompanyRequest,
  DocumentStatsResponse,
  GetInvitationDetails200Response,
  InviteMemberRequest,
  InviteMemberResponse,
  ListCompaniesResponse,
  ListPendingInvitesResponse,
  ListUsersInCompanyResponse,
  Problem,
  RemoveMemberResponse,
  ResendInvitation200Response,
  UpdateCompanyRequest,
  UpdateMemberRoleRequest,
  User,
} from '../models/index';
import {
    AcceptInviteResponseFromJSON,
    AcceptInviteResponseToJSON,
    CancelInvitation200ResponseFromJSON,
    CancelInvitation200ResponseToJSON,
    CompanyFromJSON,
    CompanyToJSON,
    CompanyDetailedFromJSON,
    CompanyDetailedToJSON,
    CreateCompanyRequestFromJSON,
    CreateCompanyRequestToJSON,
    DocumentStatsResponseFromJSON,
    DocumentStatsResponseToJSON,
    GetInvitationDetails200ResponseFromJSON,
    GetInvitationDetails200ResponseToJSON,
    InviteMemberRequestFromJSON,
    InviteMemberRequestToJSON,
    InviteMemberResponseFromJSON,
    InviteMemberResponseToJSON,
    ListCompaniesResponseFromJSON,
    ListCompaniesResponseToJSON,
    ListPendingInvitesResponseFromJSON,
    ListPendingInvitesResponseToJSON,
    ListUsersInCompanyResponseFromJSON,
    ListUsersInCompanyResponseToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    RemoveMemberResponseFromJSON,
    RemoveMemberResponseToJSON,
    ResendInvitation200ResponseFromJSON,
    ResendInvitation200ResponseToJSON,
    UpdateCompanyRequestFromJSON,
    UpdateCompanyRequestToJSON,
    UpdateMemberRoleRequestFromJSON,
    UpdateMemberRoleRequestToJSON,
    UserFromJSON,
    UserToJSON,
} from '../models/index';

export interface AcceptCompanyInviteRequest {
    token: string;
}

export interface CancelInvitationRequest {
    companyId: number;
    inviteId: number;
}

export interface CreateCompanyOperationRequest {
    createCompanyRequest: CreateCompanyRequest;
}

export interface DeleteCompanyRequest {
    companyId: number;
}

export interface GetCompanyRequest {
    companyId: number;
}

export interface GetCompanyDetailedRequest {
    companyId: number;
}

export interface GetCompanyDocumentStatsByIdRequest {
    companyId: number;
}

export interface GetInvitationDetailsRequest {
    token: string;
}

export interface InviteMemberOperationRequest {
    companyId: number;
    inviteMemberRequest: InviteMemberRequest;
}

export interface ListCompaniesRequest {
    page?: number;
    limit?: number;
}

export interface ListCompanyMembersRequest {
    companyId: number;
}

export interface ListPendingInvitesRequest {
    companyId: number;
}

export interface RemoveMemberRequest {
    companyId: number;
    userId: number;
}

export interface ResendInvitationRequest {
    companyId: number;
    inviteId: number;
}

export interface UpdateCompanyOperationRequest {
    companyId: number;
    updateCompanyRequest: UpdateCompanyRequest;
}

export interface UpdateMemberRoleOperationRequest {
    companyId: number;
    userId: number;
    updateMemberRoleRequest: UpdateMemberRoleRequest;
}

/**
 * CompaniesApi - interface
 * 
 * @export
 * @interface CompaniesApiInterface
 */
export interface CompaniesApiInterface {
    /**
     * Public endpoint to accept a company invitation using a token. User must be authenticated with Firebase. If user doesn\'t exist, they will be created and added to the company. If user exists, they will be added to the company. 
     * @summary Accept a company invitation
     * @param {string} token Invitation token from the email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    acceptCompanyInviteRaw(requestParameters: AcceptCompanyInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AcceptInviteResponse>>;

    /**
     * Public endpoint to accept a company invitation using a token. User must be authenticated with Firebase. If user doesn\'t exist, they will be created and added to the company. If user exists, they will be added to the company. 
     * Accept a company invitation
     */
    acceptCompanyInvite(requestParameters: AcceptCompanyInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AcceptInviteResponse>;

    /**
     * Deletes a pending invitation. The invitation cannot be accepted after cancellation. Requires admin or owner role in the company. Cannot cancel invitations that have already been accepted. 
     * @summary Cancel a pending invitation
     * @param {number} companyId Company ID
     * @param {number} inviteId Invitation ID to cancel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    cancelInvitationRaw(requestParameters: CancelInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CancelInvitation200Response>>;

    /**
     * Deletes a pending invitation. The invitation cannot be accepted after cancellation. Requires admin or owner role in the company. Cannot cancel invitations that have already been accepted. 
     * Cancel a pending invitation
     */
    cancelInvitation(requestParameters: CancelInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CancelInvitation200Response>;

    /**
     * 
     * @summary Create a company
     * @param {CreateCompanyRequest} createCompanyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    createCompanyRaw(requestParameters: CreateCompanyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Company>>;

    /**
     * Create a company
     */
    createCompany(requestParameters: CreateCompanyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Company>;

    /**
     * 
     * @summary Delete a company by id
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    deleteCompanyRaw(requestParameters: DeleteCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a company by id
     */
    deleteCompany(requestParameters: DeleteCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get a company by id
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    getCompanyRaw(requestParameters: GetCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Company>>;

    /**
     * Get a company by id
     */
    getCompany(requestParameters: GetCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Company>;

    /**
     * 
     * @summary Get detailed company information with aggregates
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    getCompanyDetailedRaw(requestParameters: GetCompanyDetailedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanyDetailed>>;

    /**
     * Get detailed company information with aggregates
     */
    getCompanyDetailed(requestParameters: GetCompanyDetailedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanyDetailed>;

    /**
     * 
     * @summary Get document statistics for a company (deprecated - use /api/documents/company/stats)
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    getCompanyDocumentStatsByIdRaw(requestParameters: GetCompanyDocumentStatsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentStatsResponse>>;

    /**
     * Get document statistics for a company (deprecated - use /api/documents/company/stats)
     * @deprecated
     */
    getCompanyDocumentStatsById(requestParameters: GetCompanyDocumentStatsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentStatsResponse>;

    /**
     * Public endpoint to retrieve invitation details without accepting it. Used to pre-fill signup forms with the invited email and company name. Does not require authentication. 
     * @summary Get invitation details by token
     * @param {string} token Invitation token from the email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    getInvitationDetailsRaw(requestParameters: GetInvitationDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInvitationDetails200Response>>;

    /**
     * Public endpoint to retrieve invitation details without accepting it. Used to pre-fill signup forms with the invited email and company name. Does not require authentication. 
     * Get invitation details by token
     */
    getInvitationDetails(requestParameters: GetInvitationDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInvitationDetails200Response>;

    /**
     * Sends an email invitation to join the company.  Requires admin role in the company. Creates a unique token that expires in 7 days.  Users can only belong to one company. An email associated with an existing account may be invited only when that account was removed from this same company; active accounts and accounts belonging to another company cannot be invited. 
     * @summary Invite a new member to the company
     * @param {number} companyId Company ID
     * @param {InviteMemberRequest} inviteMemberRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    inviteMemberRaw(requestParameters: InviteMemberOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InviteMemberResponse>>;

    /**
     * Sends an email invitation to join the company.  Requires admin role in the company. Creates a unique token that expires in 7 days.  Users can only belong to one company. An email associated with an existing account may be invited only when that account was removed from this same company; active accounts and accounts belonging to another company cannot be invited. 
     * Invite a new member to the company
     */
    inviteMember(requestParameters: InviteMemberOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InviteMemberResponse>;

    /**
     * 
     * @summary List companies
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    listCompaniesRaw(requestParameters: ListCompaniesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCompaniesResponse>>;

    /**
     * List companies
     */
    listCompanies(requestParameters: ListCompaniesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCompaniesResponse>;

    /**
     * Returns all users that are members of the specified company
     * @summary List all members in a company
     * @param {number} companyId Company ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    listCompanyMembersRaw(requestParameters: ListCompanyMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListUsersInCompanyResponse>>;

    /**
     * Returns all users that are members of the specified company
     * List all members in a company
     */
    listCompanyMembers(requestParameters: ListCompanyMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListUsersInCompanyResponse>;

    /**
     * Returns all invitations that have not been accepted yet
     * @summary List all pending invitations for a company
     * @param {number} companyId Company ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    listPendingInvitesRaw(requestParameters: ListPendingInvitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPendingInvitesResponse>>;

    /**
     * Returns all invitations that have not been accepted yet
     * List all pending invitations for a company
     */
    listPendingInvites(requestParameters: ListPendingInvitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPendingInvitesResponse>;

    /**
     * Removes a member from the company. Requires admin role in the company. Cannot remove yourself. Cannot remove the last admin. 
     * @summary Remove a member from the company
     * @param {number} companyId Company ID
     * @param {number} userId User ID of the member to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    removeMemberRaw(requestParameters: RemoveMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RemoveMemberResponse>>;

    /**
     * Removes a member from the company. Requires admin role in the company. Cannot remove yourself. Cannot remove the last admin. 
     * Remove a member from the company
     */
    removeMember(requestParameters: RemoveMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RemoveMemberResponse>;

    /**
     * Regenerates the invitation token, extends expiration, and resends the email. Requires admin role in the company. Invitation must not have been accepted yet. 
     * @summary Resend a pending invitation
     * @param {number} companyId Company ID
     * @param {number} inviteId Invitation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    resendInvitationRaw(requestParameters: ResendInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResendInvitation200Response>>;

    /**
     * Regenerates the invitation token, extends expiration, and resends the email. Requires admin role in the company. Invitation must not have been accepted yet. 
     * Resend a pending invitation
     */
    resendInvitation(requestParameters: ResendInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResendInvitation200Response>;

    /**
     * 
     * @summary Update a company by id
     * @param {number} companyId 
     * @param {UpdateCompanyRequest} updateCompanyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    updateCompanyRaw(requestParameters: UpdateCompanyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Company>>;

    /**
     * Update a company by id
     */
    updateCompany(requestParameters: UpdateCompanyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Company>;

    /**
     * Changes a member\'s role between \'member\' and \'admin\'. Requires admin role in the company. Cannot change your own role. 
     * @summary Update a member\'s role in the company
     * @param {number} companyId Company ID
     * @param {number} userId User ID of the member to update
     * @param {UpdateMemberRoleRequest} updateMemberRoleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApiInterface
     */
    updateMemberRoleRaw(requestParameters: UpdateMemberRoleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>>;

    /**
     * Changes a member\'s role between \'member\' and \'admin\'. Requires admin role in the company. Cannot change your own role. 
     * Update a member\'s role in the company
     */
    updateMemberRole(requestParameters: UpdateMemberRoleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User>;

}

/**
 * 
 */
export class CompaniesApi extends runtime.BaseAPI implements CompaniesApiInterface {

    /**
     * Public endpoint to accept a company invitation using a token. User must be authenticated with Firebase. If user doesn\'t exist, they will be created and added to the company. If user exists, they will be added to the company. 
     * Accept a company invitation
     */
    async acceptCompanyInviteRaw(requestParameters: AcceptCompanyInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AcceptInviteResponse>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling acceptCompanyInvite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/invites/accept/{token}`.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AcceptInviteResponseFromJSON(jsonValue));
    }

    /**
     * Public endpoint to accept a company invitation using a token. User must be authenticated with Firebase. If user doesn\'t exist, they will be created and added to the company. If user exists, they will be added to the company. 
     * Accept a company invitation
     */
    async acceptCompanyInvite(requestParameters: AcceptCompanyInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AcceptInviteResponse> {
        const response = await this.acceptCompanyInviteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a pending invitation. The invitation cannot be accepted after cancellation. Requires admin or owner role in the company. Cannot cancel invitations that have already been accepted. 
     * Cancel a pending invitation
     */
    async cancelInvitationRaw(requestParameters: CancelInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CancelInvitation200Response>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling cancelInvitation().'
            );
        }

        if (requestParameters['inviteId'] == null) {
            throw new runtime.RequiredError(
                'inviteId',
                'Required parameter "inviteId" was null or undefined when calling cancelInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/companies/{companyId}/invites/{inviteId}`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))).replace(`{${"inviteId"}}`, encodeURIComponent(String(requestParameters['inviteId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CancelInvitation200ResponseFromJSON(jsonValue));
    }

    /**
     * Deletes a pending invitation. The invitation cannot be accepted after cancellation. Requires admin or owner role in the company. Cannot cancel invitations that have already been accepted. 
     * Cancel a pending invitation
     */
    async cancelInvitation(requestParameters: CancelInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CancelInvitation200Response> {
        const response = await this.cancelInvitationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a company
     */
    async createCompanyRaw(requestParameters: CreateCompanyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Company>> {
        if (requestParameters['createCompanyRequest'] == null) {
            throw new runtime.RequiredError(
                'createCompanyRequest',
                'Required parameter "createCompanyRequest" was null or undefined when calling createCompany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/companies`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCompanyRequestToJSON(requestParameters['createCompanyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyFromJSON(jsonValue));
    }

    /**
     * Create a company
     */
    async createCompany(requestParameters: CreateCompanyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Company> {
        const response = await this.createCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a company by id
     */
    async deleteCompanyRaw(requestParameters: DeleteCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling deleteCompany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/companies/{companyId}`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a company by id
     */
    async deleteCompany(requestParameters: DeleteCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCompanyRaw(requestParameters, initOverrides);
    }

    /**
     * Get a company by id
     */
    async getCompanyRaw(requestParameters: GetCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Company>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getCompany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/companies/{companyId}`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyFromJSON(jsonValue));
    }

    /**
     * Get a company by id
     */
    async getCompany(requestParameters: GetCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Company> {
        const response = await this.getCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detailed company information with aggregates
     */
    async getCompanyDetailedRaw(requestParameters: GetCompanyDetailedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanyDetailed>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getCompanyDetailed().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/companies/{companyId}/detailed`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyDetailedFromJSON(jsonValue));
    }

    /**
     * Get detailed company information with aggregates
     */
    async getCompanyDetailed(requestParameters: GetCompanyDetailedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanyDetailed> {
        const response = await this.getCompanyDetailedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get document statistics for a company (deprecated - use /api/documents/company/stats)
     * @deprecated
     */
    async getCompanyDocumentStatsByIdRaw(requestParameters: GetCompanyDocumentStatsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentStatsResponse>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getCompanyDocumentStatsById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/companies/{companyId}/documents/stats`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentStatsResponseFromJSON(jsonValue));
    }

    /**
     * Get document statistics for a company (deprecated - use /api/documents/company/stats)
     * @deprecated
     */
    async getCompanyDocumentStatsById(requestParameters: GetCompanyDocumentStatsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentStatsResponse> {
        const response = await this.getCompanyDocumentStatsByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Public endpoint to retrieve invitation details without accepting it. Used to pre-fill signup forms with the invited email and company name. Does not require authentication. 
     * Get invitation details by token
     */
    async getInvitationDetailsRaw(requestParameters: GetInvitationDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInvitationDetails200Response>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling getInvitationDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/invites/details/{token}`.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInvitationDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Public endpoint to retrieve invitation details without accepting it. Used to pre-fill signup forms with the invited email and company name. Does not require authentication. 
     * Get invitation details by token
     */
    async getInvitationDetails(requestParameters: GetInvitationDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInvitationDetails200Response> {
        const response = await this.getInvitationDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sends an email invitation to join the company.  Requires admin role in the company. Creates a unique token that expires in 7 days.  Users can only belong to one company. An email associated with an existing account may be invited only when that account was removed from this same company; active accounts and accounts belonging to another company cannot be invited. 
     * Invite a new member to the company
     */
    async inviteMemberRaw(requestParameters: InviteMemberOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InviteMemberResponse>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling inviteMember().'
            );
        }

        if (requestParameters['inviteMemberRequest'] == null) {
            throw new runtime.RequiredError(
                'inviteMemberRequest',
                'Required parameter "inviteMemberRequest" was null or undefined when calling inviteMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/companies/{companyId}/invite`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InviteMemberRequestToJSON(requestParameters['inviteMemberRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InviteMemberResponseFromJSON(jsonValue));
    }

    /**
     * Sends an email invitation to join the company.  Requires admin role in the company. Creates a unique token that expires in 7 days.  Users can only belong to one company. An email associated with an existing account may be invited only when that account was removed from this same company; active accounts and accounts belonging to another company cannot be invited. 
     * Invite a new member to the company
     */
    async inviteMember(requestParameters: InviteMemberOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InviteMemberResponse> {
        const response = await this.inviteMemberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List companies
     */
    async listCompaniesRaw(requestParameters: ListCompaniesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCompaniesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/companies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListCompaniesResponseFromJSON(jsonValue));
    }

    /**
     * List companies
     */
    async listCompanies(requestParameters: ListCompaniesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCompaniesResponse> {
        const response = await this.listCompaniesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all users that are members of the specified company
     * List all members in a company
     */
    async listCompanyMembersRaw(requestParameters: ListCompanyMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListUsersInCompanyResponse>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling listCompanyMembers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/companies/{companyId}/members`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListUsersInCompanyResponseFromJSON(jsonValue));
    }

    /**
     * Returns all users that are members of the specified company
     * List all members in a company
     */
    async listCompanyMembers(requestParameters: ListCompanyMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListUsersInCompanyResponse> {
        const response = await this.listCompanyMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all invitations that have not been accepted yet
     * List all pending invitations for a company
     */
    async listPendingInvitesRaw(requestParameters: ListPendingInvitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPendingInvitesResponse>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling listPendingInvites().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/companies/{companyId}/invites`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListPendingInvitesResponseFromJSON(jsonValue));
    }

    /**
     * Returns all invitations that have not been accepted yet
     * List all pending invitations for a company
     */
    async listPendingInvites(requestParameters: ListPendingInvitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPendingInvitesResponse> {
        const response = await this.listPendingInvitesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes a member from the company. Requires admin role in the company. Cannot remove yourself. Cannot remove the last admin. 
     * Remove a member from the company
     */
    async removeMemberRaw(requestParameters: RemoveMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RemoveMemberResponse>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling removeMember().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling removeMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/companies/{companyId}/members/{userId}`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RemoveMemberResponseFromJSON(jsonValue));
    }

    /**
     * Removes a member from the company. Requires admin role in the company. Cannot remove yourself. Cannot remove the last admin. 
     * Remove a member from the company
     */
    async removeMember(requestParameters: RemoveMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RemoveMemberResponse> {
        const response = await this.removeMemberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Regenerates the invitation token, extends expiration, and resends the email. Requires admin role in the company. Invitation must not have been accepted yet. 
     * Resend a pending invitation
     */
    async resendInvitationRaw(requestParameters: ResendInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResendInvitation200Response>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling resendInvitation().'
            );
        }

        if (requestParameters['inviteId'] == null) {
            throw new runtime.RequiredError(
                'inviteId',
                'Required parameter "inviteId" was null or undefined when calling resendInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/companies/{companyId}/invites/{inviteId}/resend`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))).replace(`{${"inviteId"}}`, encodeURIComponent(String(requestParameters['inviteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResendInvitation200ResponseFromJSON(jsonValue));
    }

    /**
     * Regenerates the invitation token, extends expiration, and resends the email. Requires admin role in the company. Invitation must not have been accepted yet. 
     * Resend a pending invitation
     */
    async resendInvitation(requestParameters: ResendInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResendInvitation200Response> {
        const response = await this.resendInvitationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a company by id
     */
    async updateCompanyRaw(requestParameters: UpdateCompanyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Company>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling updateCompany().'
            );
        }

        if (requestParameters['updateCompanyRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCompanyRequest',
                'Required parameter "updateCompanyRequest" was null or undefined when calling updateCompany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/companies/{companyId}`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCompanyRequestToJSON(requestParameters['updateCompanyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyFromJSON(jsonValue));
    }

    /**
     * Update a company by id
     */
    async updateCompany(requestParameters: UpdateCompanyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Company> {
        const response = await this.updateCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Changes a member\'s role between \'member\' and \'admin\'. Requires admin role in the company. Cannot change your own role. 
     * Update a member\'s role in the company
     */
    async updateMemberRoleRaw(requestParameters: UpdateMemberRoleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling updateMemberRole().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updateMemberRole().'
            );
        }

        if (requestParameters['updateMemberRoleRequest'] == null) {
            throw new runtime.RequiredError(
                'updateMemberRoleRequest',
                'Required parameter "updateMemberRoleRequest" was null or undefined when calling updateMemberRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/companies/{companyId}/members/{userId}/role`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateMemberRoleRequestToJSON(requestParameters['updateMemberRoleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Changes a member\'s role between \'member\' and \'admin\'. Requires admin role in the company. Cannot change your own role. 
     * Update a member\'s role in the company
     */
    async updateMemberRole(requestParameters: UpdateMemberRoleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.updateMemberRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
